import React, { Component } from 'react';
import { toast } from 'react-toastify';
import { extractLastCardNumbers } from "../../actions/InvoiceActions";
import { Formik } from "formik";
import { AddCreditCardSchema, EditCreditCardSchema } from './schemas';
import { BootstrapError, BootstrapField } from "../../helpers/Field";
import { ERROR_PAYMENT_METHOD } from "../../constants/ErrorMessages";
import moment from "moment";
import * as cardValidator from 'card-validator';
import { connect } from "react-redux";
import { ObjectSchema } from "yup";
import { useIntl } from 'react-intl';


interface _Props {
    save: Function,
    paymentMethods: any,
    isEditing: boolean,
    alwaysSaveOnFile: boolean,
    payment: any,
    onCardConfirmed: Function
}

export function AddCreditCardForm(props: _Props) {
    const intl = useIntl();
    const f = (id, defaultMessage) => intl.formatMessage({ id, defaultMessage });
    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 11 }, (_, i) => currentYear + i);
    async function saveCard(card) {
        props.save(card);
    }

    function buttonText() {
        return f("credit_card_form.save_card_button", "Save Card");
    }

    function renderPaymentMethods() {
        console.log(props.paymentMethods);
        return (<BootstrapField component="select" name="card_type" disabled={props.isEditing}>
            <option value={""}>{f("credit_card_form.card_type_label", "Type")}</option>
            {props.paymentMethods.indexOf("VISA") !== -1 && <option value="VISA">Visa</option>}
            {props.paymentMethods.indexOf("MC") !== -1 && <option value="MC">Master Card</option>}
            {props.paymentMethods.indexOf("AMEX") !== -1 && <option value="AMEX">American Express</option>}
            {props.paymentMethods.indexOf("JCB") !== -1 && <option value="JCB">JCB</option>}
            {props.paymentMethods.indexOf("DINE") !== -1 && <option value="DINE">Diners</option>}
        </BootstrapField>)
    }

    let initialValues = {
        card_type: "",
        card_name: "",
        card_number: "",
        card_validation_code: "",
        save_on_file: props.alwaysSaveOnFile,
        make_default: false,
        card_month: "",
        card_year: "",
    };
    let schema: any = AddCreditCardSchema(intl);
    if (props.isEditing) {
        let date = moment(props.payment.valid_to, "MM-DD-YYYY");
        initialValues = {
            card_type: props.payment.payment_card_type,
            card_name: props.payment.payment_card_name,
            card_number: `ending in *${extractLastCardNumbers(props.payment.payment_card_token, '-')}`,
            card_validation_code: "",
            save_on_file: !props.payment.is_session,
            make_default: props.payment.default,
            card_month: date.format("MM"),
            card_year: date.format("YYYY"),
        };
        schema = EditCreditCardSchema(intl);
    }
    return <div>
        <div className="row">
            <div className="col-md-12">
                <Formik
                    initialValues={initialValues}
                    validationSchema={
                        schema
                    }
                    validateOnChange={true}
                    validate={(values) => {
                        let errors: any = {};
                        if (!cardValidator.expirationDate({ month: values.card_month, year: values.card_year }).isValid) {
                            errors.card_month = 'Invalid expiration date.';
                        }
                        return errors;
                    }}
                    enableReinitialize={true}
                    onSubmit={(values, bag) => {
                        bag.setSubmitting(true);
                        saveCard(values).then((paymentcard) => {
                            bag.setSubmitting(false);
                            if (props.onCardConfirmed) {
                                props.onCardConfirmed(paymentcard);
                            }
                        }).catch(() => {
                            toast.error(ERROR_PAYMENT_METHOD, { position: toast.POSITION.TOP_RIGHT });
                            bag.setSubmitting(false);
                        });
                    }}
                    render={(formProps) => (
                        <form className='payment-form' onSubmit={formProps.handleSubmit}>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className={"form-group customSelect"}>
                                        {renderPaymentMethods()}
                                        <i className="fas fa-chevron-down select-arrow"></i>
                                        <BootstrapError name="card_type" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <BootstrapField type="text" name="card_name"
                                            placeholder={f("credit_card_form.name_label", "Name on Card")} />
                                        <BootstrapError name="card_name" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <BootstrapField type="text" name="card_number"
                                            placeholder={f("credit_card_form.card_number_label", "Card Number")}
                                            disabled={props.isEditing} />
                                        <BootstrapError name="card_number" />
                                    </div>
                                </div>
                            </div>
                            <div className={"row"}>
                                <div className="col-md-4 customSelect">
                                    <BootstrapField component="select" name="card_month"
                                        placeholder={f("credit_card_form.month_label", "MM")}>
                                        <option value="">{f("credit_card_form.month_label", "MM")}</option>
                                        <option value="01">{f("calendar.months.january", "January")}</option>
                                        <option value="02">{f("calendar.months.february", "February")}</option>
                                        <option value="03">{f("calendar.months.march", "March")}</option>
                                        <option value="04">{f("calendar.months.april", "April")}</option>
                                        <option value="05">{f("calendar.months.may", "May")}</option>
                                        <option value="06">{f("calendar.months.june", "June")}</option>
                                        <option value="07">{f("calendar.months.july", "July")}</option>
                                        <option value="08">{f("calendar.months.august", "August")}</option>
                                        <option value="09">{f("calendar.months.september", "September")}</option>
                                        <option value="10">{f("calendar.months.october", "October")}</option>
                                        <option value="11">{f("calendar.months.november", "November")}</option>
                                        <option value="12">{f("calendar.months.december", "December")}</option>
                                    </BootstrapField>
                                    <i className="fas fa-chevron-down select-arrow"></i>
                                    <BootstrapError name="card_month" />
                                </div>
                                <div className="col-md-1">
                                    <span className="form-label">/</span>
                                </div>
                                <div className="col-md-4 customSelect">
                                    <BootstrapField component="select" name="card_year"
                                        placeholder={f("credit_card_form.year_label", "YY")}>
                                        <option value="">{f("credit_card_form.year_label", "YY")}</option>
                                        {years.map((year) => (
                                            <option key={year} value={year}>
                                                {year}
                                            </option>
                                        ))}
                                    </BootstrapField>
                                    <i className="fas fa-chevron-down select-arrow"></i>
                                    <BootstrapError name="card_year" />
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <BootstrapField type="text" name="card_validation_code"
                                            placeholder={f("credit_card_form.cvv_label", "CVV")} />
                                        <BootstrapError name="card_validation_code" />
                                    </div>
                                </div>
                            </div>
                            <div className={"row"}>
                                {!props.alwaysSaveOnFile &&
                                    !props.isEditing &&
                                    <div className="col-md-7">
                                        <div className="form-check">
                                            <input className="form-check-input rounded-circle" type="checkbox"
                                                checked={formProps.values.save_on_file}
                                                id="save_on_file"
                                                name={"save_on_file"} onChange={formProps.handleChange} />
                                            <label title={f("credit_card_form.disclaimer_text_tooltip",
                                                "By adding my credit card information I agree that Nobel Biocare will store this information to enable me to use the card to pay for future invoices in NobelPay or for purchases I make in the Nobel Biocare online store. I understand that I may update or remove this information at any time in NobelPay settings or by contacting customer support. For more information on how Nobel Biocare handles your personal data please read our privacy policy."
                                            ) } className="form-check-label" htmlFor="save_on_file"
                                                style={{ "paddingLeft": "24px" }}>
                                                {f("credit_card_form.save_on_file", "Save On File")}
                                                <i
                                                    className="fas fa-info-circle"
                                                    style={{
                                                        marginLeft: "8px",
                                                        color: "#dc3545",
                                                        cursor: "pointer",
                                                        fontSize: "14px",
                                                        verticalAlign: "middle",
                                                    }}
                                                />
                                            </label>
                                        </div>
                                    </div>}
                                <div className="col-md-5">
                                    {formProps.values.save_on_file && <div className="form-check">
                                        <input className="form-check-input rounded-circle" type="checkbox"
                                            checked={formProps.values.make_default}
                                            id="make_default"
                                            name={"make_default"} onChange={formProps.handleChange} />
                                        <label className="form-check-label" htmlFor="make_default"
                                            style={{ "paddingLeft": "24px" }}>
                                            {f("credit_card_form.set_as_default", "Set as default")}
                                        </label>
                                    </div>}
                                </div>
                            </div>
                            <div className="row mt-3">
                                {props.alwaysSaveOnFile && <div className="col-md-12 text-start">
                                    <label className="text-muted" style={{
                                        fontSize: "12px", lineHeight: "1.5", maxWidth: "100%",
                                        wordBreak: "break-word",
                                        whiteSpace: "normal",
                                    }}>
                                        {f("credit_card_form.disclaimer_text",
                                            "By adding my credit card information I agree that Nobel Biocare will store this information to enable me to use the card to pay for future invoices in NobelPay or for purchases I make in the Nobel Biocare online store. I understand that I may update or remove this information at any time in NobelPay settings or by contacting customer support. For more information on how Nobel Biocare handles your personal data please read our "
                                        )}
                                        <a
                                            href="https://envistaco.com/en/privacy-policy"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{ fontSize: "12px", marginLeft: "4px" }}
                                        >
                                            {f("credit_card_form.privacy_policy", "Privacy Policy")}
                                        </a>
                                    </label>
                                </div>}
                            </div>

                            <div className={"row"}>
                                <div className="col-md-12 text-center">
                                    <button className={"btn btn-primary save-card-button"}
                                        type="submit"
                                        disabled={formProps.isSubmitting}
                                    >{buttonText()}
                                    </button>
                                </div>
                            </div>
                           
                        </form>
                    )}
                />
            </div>
        </div>
    </div>;

}

export default connect<any, any, any, any>((state, props) => {
    return {
        paymentMethods: state.app.paymentMethods,
    }
})(AddCreditCardForm);

